export const DEFAULT_THEME = {
  backgroundColor: '#f1f1f1',
  primaryColor: '#013244',
  secondaryColor: '#345b69',
  accentColor: '#57bc8f',
  fontPrimaryColor: '#222',
  fontSecondaryColor: '#50535a',
  fontAccentColor: '#57bc8f',
  logoLarge: null,
  logoMedium: null,
  logoSmall: null,
};
